export default __webpack_public_path__ + "static/media/title_pc@2x.28a17dc0.png";